import type { FC, ReactNode } from "react";

import { subPaneInnerStyle, subPaneStyle } from "./CardSubPanel.css";
import { Flex } from "../Flex/Flex";
import { Text } from "../Text/Text";
import type { IconName } from "../../theme";
import type { ValueType } from "../../types";
import { ValueParser } from "../ValueParser/ValueParser";
import { Indicator } from "../Indicator/Indicator";

interface CardSubPanelProps {
  title?: string;
  value?: ValueType;
  icon?: IconName;
  trailing?: ReactNode;
}

export const CardSubPanel: FC<CardSubPanelProps> = ({
  title,
  value,
  icon,
  trailing,
}) => (
  <Flex className={value ? subPaneStyle : undefined} align="center">
    {icon && <Indicator type="square" icon={icon} />}

    <Flex
      direction="column"
      className={value ? subPaneInnerStyle : undefined}
      grow
    >
      {title && (
        <Text variant="surfaceSubtitle" color="currentColor50">
          {title}
        </Text>
      )}
      {value && (
        <Text variant="bodyL">
          <ValueParser value={value} />
        </Text>
      )}
    </Flex>

    {trailing}
  </Flex>
);
